import { j as e } from "../../../_virtual/jsx-runtime.js";
import l from "../SkeletonWrapper/index.js";
import { cn as s } from "../../../lib/utils.js";
const p = ({
  htmlFor: r,
  label: t,
  isLoading: m,
  className: o
}) => /* @__PURE__ */ e.jsx(l, { isLoading: m, children: /* @__PURE__ */ e.jsx(
  "label",
  {
    htmlFor: r,
    className: s("font-medium text-grey-600 ml-1", o),
    children: t
  }
) });
export {
  p as default
};
